import CategoriesBar from "../../globalcomponents/navbar/categorieslist/CategoriesBar";
import Navbar from "../../globalcomponents/navbar/Navbar";
import AppointmentList from "./AppointmentList";
import BookAppointmentList from "./BookAppointmentList";
import DoctorAppointment from "./DoctorAppointment";

const BookAppointment = () => {
  return (
    <>
      <div className=" display-max">
        <Navbar />
        <CategoriesBar />
        <div className=" container w-65 mt-3">
          
          <div className=" row d-flex justify-content-between align-items-start gap-3 border-bottom">
            <div className=" col-lg-3 border-end p-2">
              <b className=" text-black text-uppercase letter-spacing-1 fw-normal">
                Service List
              </b>
            </div>
            <div className=" col-lg-8 justify-content-end d-flex"></div>
          </div>
          <div className=" row d-flex justify-content-start align-items-start gap-3">
            <div className=" col-lg-3 border-end">
              <BookAppointmentList />
            </div>
            <div className=" col-lg-9">
              <AppointmentList />
            </div>
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob">
        <Navbar />
        <div className="pt-8">
          <DoctorAppointment />
        </div>
      </div>
    </>
  );
};

export default BookAppointment;
